import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, InstagramIntegrationsRespondeData } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof InstagramIntegrationsRespondeData>>

const queryKey = ["instagramIntegrations"]

export const instagramIntegrationsQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/instagram`)

      return response.data.data
    },
  })
}
